import { h } from '@/lib/dom';
import { formatRelative, daysSince } from '@/lib/format';

interface SyncSource {
  is_fresh: boolean;
  fetched_at: string | null;
}

export function SyncBadge(source: SyncSource): HTMLElement {
  const { is_fresh, fetched_at } = source;
  const when = fetched_at
    ? formatRelative(fetched_at)
    : (daysSince(fetched_at) != null ? `${daysSince(fetched_at)} дн назад` : '—');
  const color = is_fresh ? 'var(--status-norm-fg)' : 'var(--status-warn-fg)';
  const icon = is_fresh ? '✓' : '⏱';
  return h('span', {
    class: 'sync-badge',
    style: `color: ${color}; font-size: var(--text-sm);`,
  }, `${icon} синк ${when}`);
}

/**
 * Returns { text, stale } for use in Card footer spans (home.ts pattern).
 */
export function syncBadgeFooter(source: SyncSource): HTMLElement {
  const { is_fresh, fetched_at } = source;
  const days = daysSince(fetched_at);
  const text = is_fresh
    ? `Синк ${formatRelative(fetched_at)}`
    : days != null ? `Синк ${days} дн назад` : 'Синк не доступен';
  const color = is_fresh ? 'var(--status-norm-fg)' : 'var(--status-warn-fg)';
  const icon = is_fresh ? '✓' : '⏱';
  return h('span', { style: `color: ${color};` }, `${icon} ${text}`);
}
